// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sticky__container {
  position: sticky;
  z-index: 999;
  bottom: 1.5rem;
  left: 0;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
}
@media all and (min-width: 1280px) {
  .sticky__container {
    bottom: 1rem;
  }
}
.sticky__button {
  width: calc(100% - 2rem);
}
@media all and (min-width: 1280px) {
  .sticky__button {
    width: 590px;
    bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/StickyButton/StickyButton.scss"],"names":[],"mappings":"AAGE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,OAAA;EACA,qBAAA;EACA,aAAA;EACA,uBAAA;AAFJ;AAII;EATF;IAUI,YAAA;EADJ;AACF;AAIE;EACE,wBAAA;AAFJ;AAII;EAHF;IAII,YAAA;IACA,SAAA;EADJ;AACF","sourcesContent":["@import 'src/styles/variables';\n\n.sticky {\n  &__container {\n    position: sticky;\n    z-index: 999;\n    bottom: 1.5rem;\n    left: 0;\n    margin-bottom: 1.5rem;\n    display: flex;\n    justify-content: center;\n\n    @media all and (min-width: $desktop) {\n      bottom: 1rem;\n    }\n  }\n\n  &__button {\n    width: calc(100% - 2rem);\n\n    @media all and (min-width: $desktop) {\n      width: 590px;\n      bottom: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
